/* eslint-disable no-restricted-syntax */
/* eslint-disable max-len */
/* eslint-disable no-cond-assign */
import BeneficiaryFileStatus from './BeneficiaryFileStatus'
import ExamTypesEnum from './ExamTypesEnum'

const extractGlucose = (text, pureNumbers) => {
  console.log(
    '\n============== [INÍCIO EXTRAÇÃO: Glicose (Especialista)] =============='
  )
  try {
    const anchorIndex = text.findIndex((line) => /\(Sangue\)/i.test(line))
    if (anchorIndex !== -1) {
      console.debug(`  Contexto "(Sangue)" encontrado na linha: ${anchorIndex}`)
      const reversedPureNumbers = [...pureNumbers].reverse()
      const numberObject = reversedPureNumbers.find((p) => p.idx < anchorIndex)
      if (numberObject) {
        console.debug(
          `  [SUCESSO] Glicose encontrada por âncora: ${numberObject.val}`
        )
        return numberObject.val
      }
    }
    console.warn(
      '  [FALHA] Âncora "(Sangue)" não encontrada ou sem número anterior.'
    )
  } catch (e) {
    console.error('  [ERRO] na extração de Glicose', e)
  }
  return null
}

const extractByDirectConnection = (labelRegex, fullText, fieldName) => {
  console.log(
    `\n============== [INÍCIO EXTRAÇÃO: ${fieldName} (Conexão Direta)] ==============`
  )
  try {
    const regex = new RegExp(
      `${labelRegex.source}[\\s.:]*(\\d{1,3}[.,]\\d{1,2})`,
      'i'
    )
    const match = fullText.match(regex)
    if (match && match[1]) {
      const value = match[1].replace(',', '.')
      console.debug(`  [SUCESSO] ${fieldName} encontrado: ${value}`)
      return value
    }
    console.warn(
      `  [FALHA] Não foi encontrada conexão direta para ${fieldName}.`
    )
  } catch (e) {
    console.error(`  [ERRO] na extração de ${fieldName}`, e)
  }
  return null
}

const extractByBlock = (labelRegex, text, pureNumbers, fieldName) => {
  console.log(
    `\n============== [INÍCIO EXTRAÇÃO: ${fieldName} (Bloco Isolado)] ==============`
  )
  try {
    const labelIndex = text.findIndex((line) => labelRegex.test(line))
    if (labelIndex === -1) {
      console.warn(`  [FALHA] Rótulo para "${fieldName}" não encontrado.`)
      return null
    }
    console.debug(
      `  Rótulo para "${fieldName}" encontrado na linha: ${labelIndex}`
    )

    const allExamLabelsRegex = /Glicemia|Colesterol\s*Total|HDL|LDL|VLDL|Triglicérides|Não-?HDL-?C/i
    const nextLabelIndex = text.findIndex(
      (line, index) => index > labelIndex
        && allExamLabelsRegex.test(line)
        && !labelRegex.test(line)
    )
    const endIndex = nextLabelIndex !== -1 ? nextLabelIndex : text.length
    console.debug(`  Bloco definido de ${labelIndex} a ${endIndex}.`)

    let closestValueInBlock = null
    let minDistance = Infinity
    for (const p of pureNumbers) {
      if (p.idx > labelIndex && p.idx < endIndex) {
        const distance = p.idx - labelIndex
        if (distance < minDistance) {
          minDistance = distance
          closestValueInBlock = p.val
        }
      }
    }
    if (closestValueInBlock) {
      console.debug(
        `  [SUCESSO] ${fieldName} encontrado no bloco: ${closestValueInBlock}`
      )
      return closestValueInBlock
    }
    console.warn(`  [FALHA] Nenhum número encontrado no bloco de ${fieldName}.`)
  } catch (e) {
    console.error(`  [ERRO] na extração de ${fieldName}`, e)
  }
  return null
}

const extractComplexLipids = (pureNumbers) => {
  console.log(
    '\n============== [INÍCIO EXTRAÇÃO: LDL/VLDL/Não-HDL (Agrupado)] =============='
  )
  const complexLipids = {
    ldlCholesterol: null,
    vldlCholesterol: null,
    notHdl: null,
  }
  try {
    if (pureNumbers.length >= 3) {
      const tail3 = pureNumbers.slice(-3).map((p) => p.val)
      const [valNaoHdl, valLdl, valVldl] = tail3
      complexLipids.notHdl = valNaoHdl
      complexLipids.ldlCholesterol = valLdl
      complexLipids.vldlCholesterol = valVldl
      console.debug(
        '  [SUCESSO] Lipídios Complexos extraídos do grupo final:',
        complexLipids
      )
    } else {
      console.warn(
        '  [FALHA] Não há números puros suficientes para extrair os lipídios complexos.'
      )
    }
  } catch (e) {
    console.error('  [ERRO] na extração de Lipídios Complexos', e)
  }
  return complexLipids
}
export const getDataFromLaboratoryText = (text) => {
  try {
    console.log(
      '--- MAPA COMPLETO DO TEXTO (INPUT BRUTO) ---',
      JSON.stringify(text, null, 2)
    )

    const fullText = text.join(' ')
    const pureNumbers = text
      .map((line, idx) => ({ line: line.trim(), idx }))
      .filter(({ line }) => /^\d+(?:[.,]\d+)?$/.test(line))
      .map(({ line, idx }) => ({ idx, val: line.replace(',', '.') }))

    console.debug(
      '\n[Parser] "pureNumbers" extraídos:',
      pureNumbers.map((p) => `${p.idx}:${p.val}`)
    )

    const glucose = extractGlucose(text, pureNumbers)
    const totalCholesterol = extractByDirectConnection(
      /Colesterol\s*Total/i,
      fullText,
      'Colesterol Total'
    )
    const hdlCholesterol = extractByDirectConnection(
      /Colesterol\s*HDL/i,
      fullText,
      'Colesterol HDL'
    )
    const triglycerides = extractByBlock(
      /Triglicérides/i,
      text,
      pureNumbers,
      'Triglicérides'
    )
    const { ldlCholesterol, vldlCholesterol, notHdl } = extractComplexLipids(pureNumbers)

    const nameIndex = text.findIndex((l) => /A interpretação do resultado/i.test(l))
    const name = nameIndex !== -1 ? text[nameIndex + 1]?.trim() || '' : ''
    console.debug(
      `\n[Parser] Nome do paciente extraído: ${name || 'Não encontrado'}`
    )

    const result = {
      beneficiaryFileName: name,
      examType: ExamTypesEnum.Laboratorial,
      glucose,
      totalCholesterol,
      hdlCholesterol,
      ldlCholesterol,
      vldlCholesterol,
      triglycerides,
      notHdl,
    }
    console.log('\n============== [RESULTADO FINAL] ============== \n', result)

    if (glucose && triglycerides) {
      return result
    }

    console.warn(
      '[Parser] Falha na validação mínima (Glicose ou Triglicérides ausentes)'
    )
    return {
      examType: ExamTypesEnum.Laboratorial,
      beneficiaryFileName: '',
      findStatus: BeneficiaryFileStatus.withError.id,
    }
  } catch (error) {
    console.error(
      '[Parser] Exceção GERAL na função getDataFromLaboratoryText:',
      error
    )
    return {
      examType: ExamTypesEnum.Laboratorial,
      beneficiaryFileName: '',
      findStatus: BeneficiaryFileStatus.withError.id,
    }
  }
}
